module.exports = "/static/assets/81d5d1258558641e78d425193753207c.svg";